import React, { useRef, useState } from 'react';

const NewsCardDeck = ({ cards, linkFor }) => {
  const trackRef = useRef(null);
  const [active, setActive] = useState(0);
  const rows = (cards || []).filter((card) => card?.title);
  if (!rows.length) return null;

  const goTo = (index) => {
    const track = trackRef.current;
    const target = track?.children[index];
    if (!track || !target) return;
    track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };

  const handleScroll = () => {
    const track = trackRef.current;
    if (!track?.clientWidth) return;
    setActive(Math.round(track.scrollLeft / track.clientWidth));
  };

  return (
    <section className="news-deck" aria-roledescription="carousel" aria-label="카드뉴스로 보는 오늘 소식">
      <div className="news-deck-track" ref={trackRef} onScroll={handleScroll}>
        {rows.map((card, index) => (
          <article
            key={`${card.kind}-${index}`}
            className={`news-deck-card news-deck-card--${card.kind}`}
            aria-roledescription="slide"
            aria-label={`${index + 1} / ${rows.length}`}
          >
            {card.image_url ? (
              <img className="news-deck-image" data-testid="news-card-image" src={card.image_url} alt="" loading={index === 0 ? 'eager' : 'lazy'} />
            ) : (
              <div className="news-deck-image news-deck-image--empty" aria-hidden="true" />
            )}
            <div className="news-deck-text">
              <p className="news-deck-eyebrow">{card.eyebrow}</p>
              <h2 className="news-deck-title">{card.title}</h2>
              {card.body && card.body !== card.title && <p className="news-deck-body">{card.body}</p>}
              {linkFor?.(card) && (
                <a className="news-deck-more" href={linkFor(card)}>
                  {card.kind === 'quiz' ? '퀴즈 풀러 가기' : '자세히 보기'}
                  <span aria-hidden="true"> ›</span>
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
      {rows.length > 1 && (
        <div className="news-deck-nav">
          <button
            type="button"
            className="news-deck-arrow"
            onClick={() => goTo(Math.max(active - 1, 0))}
            disabled={active === 0}
            aria-label="이전 카드"
          >
            ‹
          </button>
          <div className="news-deck-dots">
            {rows.map((card, index) => (
              <button
                key={`dot-${card.kind}-${index}`}
                type="button"
                className={`news-deck-dot ${index === active ? 'is-active' : ''}`}
                onClick={() => goTo(index)}
                aria-label={`${index + 1}번째 카드 보기`}
                aria-current={index === active ? 'true' : undefined}
              />
            ))}
          </div>
          <button
            type="button"
            className="news-deck-arrow"
            onClick={() => goTo(Math.min(active + 1, rows.length - 1))}
            disabled={active === rows.length - 1}
            aria-label="다음 카드"
          >
            ›
          </button>
        </div>
      )}
    </section>
  );
};

export default NewsCardDeck;
